import React from 'react';
import { useNavigate } from 'react-router-dom';
import TruncatedCell from '../../components/TruncatedCell';
import Pagination from '../../components/Pagination';
import { PriorityBadgeCompact } from '../../components/PriorityBadge';
import { formatToJST } from '../../utils/dateFormatter';

const ProposedJobsTab = ({
    opportunityId,
    proposedJobs,
    handleOpenJobDetail,
    handleClickGenerateRecommendation,
    recommendationLoading,
    handleOpenJobModal,
    jobsPage,
    setJobsPage,
    jobsTotalPages,
    jobsTotal,
    jobsPerPage
}) => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <div className="activities-tab-actions">
                <button
                    className="modal-button-confirm"
                    onClick={handleClickGenerateRecommendation}
                    disabled={recommendationLoading}
                    style={{ marginRight: '10px' }}
                >
                    ✨ AI推薦文
                </button>
                <button className="modal-button-confirm" onClick={handleOpenJobModal} style={{ marginRight: '10px' }}>
                    + 求人追加
                </button>
                {/* SCR-M-001 AI マッチング画面への入口 (T-002-U3、SCR-E-004 既存拡張) */}
                <button
                    className="modal-button-confirm"
                    onClick={() => navigate(`/opportunity/${opportunityId}/matching`)}
                >
                    ✨ AI マッチングを開始
                </button>
            </div>

            <div className="table-responsive">
                {proposedJobs && proposedJobs.length > 0 ? (
                    <table>
                        <thead>
                            <tr>
                                <th>企業名</th>
                                <th style={{ width: '100px', textAlign: 'center' }}>優先度</th>
                                <th>作成日時</th>
                            </tr>
                        </thead>
                        <tbody>
                            {proposedJobs.map((job) => (
                                <tr
                                    key={job.id}
                                    className="clickable-row"
                                    onClick={() => handleOpenJobDetail(job)}
                                >
                                    <td>
                                        <TruncatedCell text={job.company_name} />
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <PriorityBadgeCompact priority={job.priority} />
                                    </td>
                                    <td>
                                        {formatToJST(job.created_at)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p className="no-data">提案した求人がありません。</p>
                )}
            </div>

            {jobsTotalPages > 0 && (
                <Pagination
                    currentPage={jobsPage}
                    totalPages={jobsTotalPages}
                    totalItems={jobsTotal}
                    perPage={jobsPerPage}
                    onPageChange={setJobsPage}
                />
            )}
        </React.Fragment>
    );
};

export default ProposedJobsTab;
